/**
 * Leaf date helpers — no imports from within prescription_ingestion, so both PrescriptionDefaults
 * and PrescriptionHelpers (which form an import cycle via MEDICATIONS) can import these without
 * creating or aggravating that cycle.
 */

/** Current date as YYYY-MM-DD in Pacific time (PST/PDT). */
export const getCurrentDateString = (): string => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Los_Angeles",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(new Date());
  const get = (type: string) => parts.find((p) => p.type === type)?.value || "";
  return `${get("year")}-${get("month")}-${get("day")}`;
};

/** A YYYY-MM-DD date shifted by whole years; Feb 29 becomes Feb 28 when the target year has none. */
export const addYears = (date: string, years: number): string => {
  const [year, month, day] = date.split("-").map(Number);
  const targetYear = year + years;
  const isLeapYear = (targetYear % 4 === 0 && targetYear % 100 !== 0) || targetYear % 400 === 0;
  const targetDay = month === 2 && day === 29 && !isLeapYear ? 28 : day;
  return `${targetYear}-${String(month).padStart(2, "0")}-${String(targetDay).padStart(2, "0")}`;
};

/** A YYYY-MM-DD date shifted by whole days (negative moves it back). */
export const addDays = (date: string, days: number): string => {
  const shifted = new Date(`${date}T00:00:00Z`);
  shifted.setUTCDate(shifted.getUTCDate() + days);
  return shifted.toISOString().split("T")[0];
};
